"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const react_i18next_1 = require("react-i18next");
const faGithub_1 = require("@fortawesome/free-brands-svg-icons/faGithub");
const faBook_1 = require("@fortawesome/free-solid-svg-icons/faBook");
const faEnvelope_1 = require("@fortawesome/free-solid-svg-icons/faEnvelope");
const Button_1 = require("../Button");
const user_json_1 = __importDefault(require("../../../dist/user.json"));
const BUTTON_DATA = [
    {
        text: 'GitHub',
        href: user_json_1.default.githubUrl,
        icon: faGithub_1.faGithub,
    },
    {
        text: 'Blog',
        href: user_json_1.default.blog,
        icon: faBook_1.faBook,
    },
    {
        text: 'Email',
        href: user_json_1.default.email ? 'mailto:' + user_json_1.default.email : undefined,
        icon: faEnvelope_1.faEnvelope,
    },
].filter((i) => i.href);
const SectionWrapper = styled_components_1.default.div `
  display: flex;

  & > * + * {
    margin-left: 20px;
  }
`;
const Section = ({ children }) => ((0, jsx_runtime_1.jsx)(SectionWrapper, { children: children }));
const Content = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(Section, { children: BUTTON_DATA.map(({ text, ...restProps }) => ((0, jsx_runtime_1.jsx)(Button_1.AnchorButton, { text: (text && t(text)) ?? undefined, target: "_blank", rel: "noreferrer", ...restProps }, text))) }));
};
exports.default = Content;
